import { View, Text, FlatList, Button, TextInput, Switch } from "react-native";
import React, { useEffect, useState } from "react";
import Product from "../components/Product";
import Images from "../assets/img";
import Collection from "../components/Collection";
import {
  collection,
  query,
  where,
  getDocs,
  getDoc,
  doc,
  setDoc,
} from "firebase/firestore";
import { auth, db } from "../firebase.js";
import { styles } from "../styles/mainStyle";
import { signOut } from "firebase/auth";
import { useStateContext } from "../lib/context";
import Header from "../components/Header";
import { ScrollView, TouchableOpacity } from "react-native-web";
import Ionicons from "@expo/vector-icons/Ionicons";

const StoreAdmin = ({ navigation }) => {
  const [productos, setProductos] = useState([]);
  const [search, setSearch] = useState("");
  const [produ, setProdu] = useState([]);
  const [disp, setDisp] = useState(false);
  const [typeGrid, setTypeGrid] = useState(true);
  const [cliente, setCliente] = useState("");

  const { ahora } = useStateContext();

  const logOut = () => {
    signOut(auth)
      .then(() => {
        navigation.replace("Login");
      })
      .catch((error) => {
        // An error happened.
      });
  };

  // TODO fix this
  useEffect(() => {
    productos.push(
      {
        subfamilia: "ARANDELAS VARIAS",
        stock: "0",
        sku: "A-00008-0",
        tipo: "9 - OTROS",
        familia: "A-",
        precio: "20",
        nombre: "ARANDELA SEGURO SACHS 98",
      },
      {
        stock: "181",
        subfamilia: "A-",
        precio: "7.6",
        sku: "A-00010-0",
        familia: "A-",
        nombre: "ARAND. SEGURO EMBRAGUE PUMA 4TA",
        tipo: "9 - OTROS",
      },
      {
        familia: "A-",
        nombre: "ARANDELA COMPENSACION",
        sku: "A-00013-0",
        stock: "0",
        subfamilia: "A-",
        tipo: "9 - OTROS",
        precio: "1.344",
      },
      {
        stock: "0",
        precio: "5.912",
        familia: "A-",
        tipo: "9 - OTROS",
        nombre: "ARANDELA CUBRE RETEN SACHS",
        subfamilia: "A-",
        sku: "A-00014-0",
      },
      {
        sku: "A-00015-0",
        stock: "0",
        familia: "A-",
        nombre: "ARANDELA LISA",
        tipo: "9 - OTROS",
        precio: "2.692",
        subfamilia: "A-",
      },
      {
        subfamilia: "A-",
        nombre: "ARANDELA PLANETARIO SACHS 98",
        familia: "A-",
        precio: "9.66",
        tipo: "9 - OTROS",
        sku: "A-00018-0",
        stock: "0",
      },
      {
        nombre: "ARANDELA COMPENSACION 0 12",
        stock: "30",
        familia: "A-",
        tipo: "9 - OTROS",
        sku: "A-00022-0",
        precio: "1.828",
        subfamilia: "A-",
      },
      {
        tipo: "9 - OTROS",
        familia: "A-",
        nombre: "ARANDELA DE COMP.10X15",
        sku: "A-00023-0",
        subfamilia: "A-",
        stock: "0",
        precio: "2.6",
      },
      {
        precio: "2.132",
        familia: "A-",
        nombre: "ARANDELA DE COMP.10X18",
        stock: "31",
        tipo: "9 - OTROS",
        subfamilia: "A-",
        sku: "A-00024-0",
      },
      {
        familia: "A-",
        nombre: "ARANDELA DE COMP.20,5 X 25",
        tipo: "9 - OTROS",
        precio: "2.028",
        stock: "16",
        subfamilia: "ARANDELAS COMPENSACION",
        sku: "A-00025-0",
      },
      {
        familia: "A-",
        stock: "0",
        subfamilia: "A-",
        sku: "A-00026-0",
        precio: "1.604",
        nombre: "ARANDELA 12X23",
        tipo: "9 - OTROS",
      },
      {
        nombre: "ARANDELA COMPENSACION",
        tipo: "9 - OTROS",
        sku: "A-00027-0",
        precio: "1.344",
        stock: "0",
        subfamilia: "A-",
        familia: "A-",
      },
      {
        familia: "A-",
        stock: "0",
        tipo: "9 - OTROS",
        precio: "1.936",
        subfamilia: "A-",
        sku: "A-00031-0",
        nombre: "ARANDELA COMP.16 X 20.CUADRUPLE",
      },
      {
        familia: "A-",
        tipo: "9 - OTROS",
        subfamilia: "ARANDELAS COMPENSACION",
        precio: "2.904",
        nombre: "ARAND.CIG.GIL.150 Y SACHS 21,2X29",
        stock: "144",
        sku: "A-00035-0",
      },
      {
        tipo: "9 - OTROS",
        stock: "527",
        subfamilia: "ARANDELAS VARIAS",
        familia: "A-",
        precio: "8.164",
        nombre: "SEGURO EMBRAGUE GIL.150",
        sku: "A-00036-0",
      },
      {
        familia: "A-",
        tipo: "9 - OTROS",
        subfamilia: "ARANDELAS VARIAS",
        stock: "316",
        sku: "A-00037-0",
        precio: "8.164",
        nombre: "ARANDELA SEGURIDAD SELECTOR GIL.",
      },
      {
        subfamilia: "A-",
        nombre: "ARANDELA ARBOL DE LEVAS GIL.200",
        tipo: "9 - OTROS",
        sku: "A-00038-0",
        familia: "A-",
        precio: "1.936",
        stock: "0",
      },
      {
        nombre: "ARANDELA COMP.24X17,4",
        sku: "A-00040-0",
        familia: "A-",
        precio: "1.936",
        subfamilia: "ARANDELAS COMPENSACION",
        stock: "0",
        tipo: "9 - OTROS",
      },
      {
        familia: "A-",
        subfamilia: "A-",
        stock: "1",
        nombre: "CIGUEÑAL GILERA 150",
        precio: "1.936",
        sku: "A-00041-0",
        tipo: "9 - OTROS",
      },
      {
        tipo: "9 - OTROS",
        nombre: "ARANDELA DE COMPENSACION",
        precio: "2.312",
        familia: "A-",
        stock: "0",
        sku: "A-00055-0",
        subfamilia: "A-",
      },
      {
        precio: "2.344",
        familia: "A-",
        subfamilia: "ARANDELAS VARIAS",
        nombre: "ARANDELA EJE SECUNDARIO SIAM 125",
        stock: "63",
        tipo: "9 - OTROS",
        sku: "A-00056-0",
      },
      {
        nombre: "ARANDELA SEGURO EMBRAGUE SIAM 125",
        precio: "5.368",
        subfamilia: "ARANDELAS VARIAS",
        familia: "A-",
        stock: "364",
        tipo: "9 - OTROS",
        sku: "A-00060-0",
      },
      {
        precio: "21.472",
        subfamilia: "ARANDELAS VARIAS",
        tipo: "9 - OTROS",
        stock: "14",
        sku: "A-00063-0",
        nombre: "ARANDELA ELASTICA SIAM",
        familia: "A-",
      },
      {
        precio: "5.912",
        nombre: "ARANDELA SEGURIDAD PERNO SIAM",
        stock: "170",
        tipo: "9 - OTROS",
        familia: "A-",
        sku: "A-00064-0",
        subfamilia: "ARANDELAS VARIAS",
      },
      {
        tipo: "9 - OTROS",
        familia: "A-",
        subfamilia: "ARANDELAS VARIAS",
        stock: "1265",
        nombre: "ARANDELA SEGURO PUNTA CIGUE#AL",
        precio: "5.368",
        sku: "A-00066-0",
      },
      {
        sku: "A-00067-0",
        nombre: "ARANDELA TOPE SUSP.SIAM 125",
        stock: "0",
        tipo: "9 - OTROS",
        familia: "A-",
        subfamilia: "ARANDELAS VARIAS",
        precio: "5.912",
      },
      {
        subfamilia: "ARANDELAS VARIAS",
        nombre: "ARANDELA SEGURO CIG.SIAM 150",
        stock: "133",
        tipo: "9 - OTROS",
        familia: "A-",
        sku: "A-00068-0",
        precio: "13.32",
      },
      {
        sku: "A-00069-0",
        nombre: "ARANDELA DE COMP.",
        precio: "1.284",
        familia: "A-",
        stock: "0",
        tipo: "9 - OTROS",
        subfamilia: "A-",
      },
      {
        precio: "1.936",
        familia: "A-",
        stock: "0",
        tipo: "9 - OTROS",
        subfamilia: "ARANDELAS COMPENSACION",
        sku: "A-00074-0",
        nombre: "ARNDELA COMPENSACION 20,5X25",
      },
      {
        stock: "1110",
        subfamilia: "A-",
        precio: "8.164",
        tipo: "9 - OTROS",
        nombre: "ARAND.COMP.CAJA SAPUCAI 18,2X34",
        familia: "A-",
        sku: "A-00086-0",
      },
      {
        precio: "1.604",
        sku: "A-00087-0",
        subfamilia: "ARANDELAS COMPENSACION",
        nombre: "ARANDELA COMP.22,3X28 ZLLA 200",
        tipo: "9 - OTROS",
        familia: "A-",
        stock: "2646",
      },
      {
        nombre: "ARANDELA COMP.CIG.25X35",
        sku: "A-00088-0",
        tipo: "9 - OTROS",
        familia: "A-",
        precio: "5.596",
        subfamilia: "ARANDELAS COMPENSACION",
        stock: "1109",
      },
      {
        tipo: "9 - OTROS",
        stock: "1271",
        familia: "A-",
        precio: "1.344",
        sku: "A-00090-0",
        subfamilia: "ARANDELAS VARIAS",
        nombre: "ARANDELA SELECTOR CAMBIO ZLLA 200",
      },
      {
        sku: "A-00093-0",
        subfamilia: "ARANDELAS COMPENSACION",
        nombre: "ARANDELA CIGUE#AL ZLLA 200",
        stock: "1608",
        precio: "3.552",
        tipo: "9 - OTROS",
        familia: "A-",
      },
      {
        tipo: "9 - OTROS",
        nombre: "ASIENTO RESORTE ZLLA 125/175/180",
        familia: "A-",
        precio: "5.596",
        subfamilia: "ARANDELAS VARIAS",
        stock: "409",
        sku: "A-00244-0",
      },
      {
        precio: "5.46",
        stock: "1011",
        tipo: "9 - OTROS",
        familia: "A-",
        nombre: "SEGURO EMBRAGUE ZLLA 125",
        subfamilia: "ARANDELAS VARIAS",
        sku: "A-00250-0",
      },
      {
        precio: "1.964",
        sku: "A-01040-0",
        nombre: "ARANDELA EJE ARRANQUE GIL.200",
        stock: "0",
        subfamilia: "A-",
        familia: "A-",
        tipo: "9 - OTROS",
      },
      {
        sku: "A-01044-0",
        nombre: "ARANDELA COMPENSACION",
        subfamilia: "A-",
        stock: "0",
        precio: "0.332",
        tipo: "9 - OTROS",
        familia: "A-",
      },
      {
        tipo: "9 - OTROS",
        stock: "0",
        precio: "4",
        subfamilia: "SIN FAMILIA",
        familia: "SIN FAMILIA",
        nombre: "ART_IMP_EXEN",
        sku: "ART_IMP_EXEN",
      },
      {
        tipo: "9 - OTROS",
        subfamilia: "SIN FAMILIA",
        sku: "ART_IMP_GRAV",
        precio: "4",
        stock: "0",
        nombre: "ART_IMP_GRAV",
        familia: "SIN FAMILIA",
      },
      {
        stock: "180",
        nombre: "KIT SEGURO - BULON - TUERCA CORONA YBR",
        familia: "B-",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
        subfamilia: "B-",
        sku: "B-00099-2",
        precio: "296.027",
      },
      {
        subfamilia: "B-",
        stock: "2",
        familia: "B-",
        precio: "443.273",
        nombre: "KIT SEGURO - BULON - TCA  CORONA 11",
        sku: "B-00099-3",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
      },
      {
        precio: "204.961",
        stock: "184",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
        subfamilia: "TUERCAS",
        sku: "B-00233-0",
        nombre: "TUERCA EJE RUEDA DEL.GIL.200 12X1.",
        familia: "B-",
      },
      {
        stock: "417",
        nombre: "TUERCA CENTRO EMB.ZLLA 125 Y SAP.",
        subfamilia: "TUERCAS",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
        precio: "336.782",
        sku: "B-00235-0",
        familia: "B-",
      },
      {
        subfamilia: "TUERCAS",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
        nombre: "TUERCA PIÑON PUMA 4TA.12X100 IZQ.",
        sku: "B-00236-0",
        stock: "13",
        precio: "215.807",
        familia: "B-",
      },
      {
        stock: "2",
        sku: "B-00237-0",
        familia: "B-",
        nombre: "TUERCA PIÑON GIL.200 12X100 DERECH",
        precio: "244.812",
        subfamilia: "TUERCAS",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
      },
      {
        familia: "B-",
        precio: "109.578",
        stock: "348",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
        nombre: "TUERCA EJES DE RUEDA ZLLA 14X14.5",
        subfamilia: "TUERCAS",
        sku: "B-00238-0",
      },
      {
        stock: "8",
        familia: "B-",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
        sku: "B-00239-0",
        subfamilia: "TUERCAS",
        precio: "311.205",
        nombre: "TUERCA EMBRAGUE SIAM 125/150",
      },
      {
        precio: "33.539",
        familia: "B-",
        nombre: "TUERCA FARO GUIÑO 10X1.25 ALTAS",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
        subfamilia: "TUERCAS",
        sku: "B-00240-0",
        stock: "5675",
      },
      {
        stock: "287",
        sku: "B-00241-0",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
        familia: "B-",
        nombre: "TUERCA ARBOL DE LEVAS GIL.200",
        precio: "165.119",
        subfamilia: "TUERCAS",
      },
      {
        subfamilia: "TUERCAS",
        stock: "185",
        precio: "408.453",
        familia: "B-",
        nombre: "TUERCA FIJACION MOTOR SIAM 18X1.5",
        sku: "B-00242-0",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
      },
      {
        precio: "435.016",
        stock: "116",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
        familia: "B-",
        nombre: "TUERCA EMB.PUMA2DA(50506)",
        subfamilia: "TUERCAS",
        sku: "B-00243-0",
      },
      {
        nombre: "TUERCA EMB.PUMA 4TA.(52506)",
        subfamilia: "TUERCAS",
        precio: "531.308",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
        sku: "B-00244-0",
        stock: "41",
        familia: "B-",
      },
      {
        precio: "435.016",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
        sku: "B-00246-0",
        subfamilia: "TUERCAS",
        stock: "18",
        nombre: "TUERCA CASTILLO PALIERS VESPA",
        familia: "B-",
      },
      {
        subfamilia: "TUERCAS",
        familia: "B-",
        precio: "101.64",
        nombre: "TUERCA VARILLAS FRENOS 6X100",
        stock: "576",
        sku: "B-00247-0",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
      },
      {
        stock: "280",
        familia: "B-",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
        precio: "268.045",
        subfamilia: "TUERCAS",
        nombre: "TUERCA VARILLA FRENO DIAM.7",
        sku: "B-00247-1",
      },
      {
        stock: "0",
        subfamilia: "TUERCAS",
        sku: "B-00248-0",
        familia: "B-",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
        precio: "217.271",
        nombre: "TUERCA DE FRENO GIL.5X0,80",
      },
      {
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
        nombre: "TUERCA PIÑON GIL.150 (SEMI CIEGA)",
        familia: "B-",
        precio: "241.412",
        stock: "83",
        sku: "B-00249-0",
        subfamilia: "TUERCAS",
      },
      {
        precio: "165.119",
        sku: "B-00250-0",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
        stock: "0",
        nombre: "TUERCA CILINDRO SIAM 125/ZLLA 50",
        subfamilia: "TUERCAS",
        familia: "B-",
      },
      {
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
        sku: "B-00251-0",
        nombre: "TUERCA CIL.SIAM 150 7x100",
        stock: "174",
        subfamilia: "TUERCAS",
        precio: "158.473",
        familia: "B-",
      },
      {
        precio: "189.226",
        subfamilia: "TUERCAS",
        nombre: "TUERCAS CIL.ZLLA 125",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
        sku: "B-00252-0",
        familia: "B-",
        stock: "0",
      },
      {
        familia: "B-",
        precio: "167.455",
        sku: "B-00253-0",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
        subfamilia: "TUERCAS",
        stock: "12",
        nombre: "TUERCA REG.VALV.GIL.200/150/175",
      },
      {
        subfamilia: "TUERCAS",
        familia: "B-",
        precio: "344.423",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
        nombre: "TUERCA EJE BRAZO OSC.PUMA 15X1.5",
        sku: "B-00254-0",
        stock: "0",
      },
      {
        precio: "261.876",
        sku: "B-00255-0",
        stock: "15",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
        nombre: "TUERCA BRAZO OSC.(PASAN)GIL.14X1.2",
        familia: "B-",
        subfamilia: "TUERCAS",
      },
      {
        familia: "B-",
        nombre: "TUERCA CIEGA BRAZO OSC.GIL.200",
        stock: "14",
        precio: "314.039",
        subfamilia: "TUERCAS",
        sku: "B-00256-0",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
      },
      {
        precio: "347.254",
        nombre: "TUERCA CIEGA EJE RUEDA SIAM 12X1.5",
        stock: "2",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
        subfamilia: "TUERCAS",
        sku: "B-00257-0",
        familia: "B-",
      },
      {
        familia: "B-",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
        nombre: "TUERCA CIEGA AMORT.GIL.12X1.5",
        sku: "B-00258-0",
        precio: "249.965",
        subfamilia: "TUERCAS",
        stock: "1",
      },
      {
        stock: "113",
        sku: "B-00259-0",
        familia: "B-",
        precio: "202.551",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
        nombre: "TUERCA.CIEGA CAMBIO GIL.200 10X100",
        subfamilia: "TUERCAS",
      },
      {
        subfamilia: "TUERCAS",
        nombre: "TUERCA CIEGA EJE RUEDA TRAS.GIL200",
        stock: "0",
        precio: "249.965",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
        familia: "B-",
        sku: "B-00260-0",
      },
      {
        sku: "B-00261-0",
        stock: "215",
        subfamilia: "TUERCAS",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
        familia: "B-",
        precio: "207.785",
        nombre: "TUERCA CIEGA AMORT.ZLLA 125",
      },
      {
        subfamilia: "BULONES",
        precio: "119.536",
        familia: "B-",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
        stock: "411",
        nombre: "BULON 7X45 T/ROSCA CORONA SAPUC.",
        sku: "B-00264-0",
      },
      {
        sku: "B-00265-0",
        familia: "B-",
        nombre: "BULON SOPORTE MOTOR SUPERIOR 110",
        subfamilia: "BULONES",
        precio: "243.08",
        stock: "410",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
      },
      {
        precio: "227.703",
        nombre: "TUERCA CENTRO EMB.GIL.200",
        stock: "5",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
        familia: "B-",
        subfamilia: "TUERCAS",
        sku: "B-00267-0",
      },
      {
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
        sku: "B-00269-0",
        precio: "206.832",
        nombre: "TUERCA 8X1.25 IZQUIERDA",
        familia: "B-",
        stock: "0",
        subfamilia: "TUERCAS",
      },
      {
        familia: "B-",
        precio: "224.905",
        nombre: "TUERCA 10X100 BAJAIZQ.CIG.LADO EMB",
        subfamilia: "TUERCAS",
        sku: "B-00270-0",
        stock: "1",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
      },
      {
        nombre: "TUERCA CAMPANA EMB.VESPA",
        subfamilia: "TUERCAS",
        familia: "B-",
        sku: "B-00271-0",
        precio: "376.686",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
        stock: "3",
      },
      {
        familia: "B-",
        sku: "B-00272-0",
        stock: "2",
        subfamilia: "TUERCAS VOLANTE",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
        nombre: "TUERCA VOLANTE VESPA",
        precio: "465.358",
      },
      {
        stock: "1",
        precio: "415.081",
        nombre: "TUERCA PIÑON ZLLA 125 (SEMICIEGA)",
        subfamilia: "TUERCAS",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
        sku: "B-00273-0",
        familia: "B-",
      },
      {
        familia: "B-",
        subfamilia: "TUERCAS",
        precio: "442.133",
        stock: "1145",
        sku: "B-00274-0",
        nombre: "TUERCA PIÑON D.K.W.125",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
      },
      {
        subfamilia: "TUERCAS",
        familia: "B-",
        nombre: "TUERCA CIEGA PALIERS SIAM/T.V.",
        sku: "B-00275-0",
        stock: "23",
        precio: "578.723",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
      },
      {
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
        familia: "B-",
        precio: "405.137",
        subfamilia: "TUERCAS VOLANTE",
        nombre: "TUERCA VOLANTE ZLLA 175 / 200",
        sku: "B-00276-0",
        stock: "0",
      },
      {
        familia: "B-",
        nombre: "TUERCA VOLANTE SIAM T.V.",
        subfamilia: "TUERCAS VOLANTE",
        stock: "1",
        precio: "379.045",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
        sku: "B-00277-0",
      },
      {
        nombre: "TUERCA CIGUEÑAL SIAM 150 19X100",
        subfamilia: "TUERCAS",
        stock: "56",
        sku: "B-00278-0",
        precio: "398.453",
        familia: "B-",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
      },
      {
        familia: "B-",
        nombre: "TUERCA POSAPIE ZLLA (18X1.5)",
        stock: "307",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
        subfamilia: "TUERCAS",
        precio: "303.111",
        sku: "B-00279-0",
      },
      {
        sku: "B-00281-0",
        nombre: "TUERCA CILINDRO VESPA 150",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
        stock: "106",
        subfamilia: "TUERCAS",
        familia: "B-",
        precio: "232.915",
      },
      {
        stock: "21",
        nombre: "TUERCA MOTOR ISO",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
        familia: "B-",
        precio: "407.971",
        subfamilia: "TUERCAS",
        sku: "B-00282-0",
      },
      {
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
        nombre: "SEPARADOR RUEDA DEL.GIL.150 ALTO",
        subfamilia: "SEPARADORES RUEDAS",
        precio: "253.785",
        stock: "1772",
        familia: "B-",
        sku: "B-00283-0",
      },
      {
        stock: "518",
        nombre: "REGULADORES DE EMB.GIL.200",
        subfamilia: "B-",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
        familia: "B-",
        precio: "184.977",
        sku: "B-00284-0",
      },
      {
        subfamilia: "B-",
        stock: "32",
        nombre: "PERILLAS CAJA BATERIA GIL.MACHO",
        familia: "B-",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
        sku: "B-00286-0",
        precio: "466.769",
      },
      {
        precio: "793.524",
        familia: "B-",
        subfamilia: "EXTRACTORES VOLANTE",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
        nombre: "EXTRACTOR VOLANTE DOBLE ZLLA 50 Y SAPU",
        sku: "B-00287-0",
        stock: "0",
      },
      {
        subfamilia: "ARANDELAS",
        sku: "B-00288-0",
        stock: "0",
        familia: "B-",
        precio: "32.286",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
        nombre: "ARANDELAS DE COMP.PUMA (53637)",
      },
      {
        precio: "147.03",
        nombre: "BULONES CRUCETA SIAM 125",
        subfamilia: "B-",
        stock: "37",
        familia: "B-",
        sku: "B-00290-0",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
      },
      {
        precio: "120.053",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
        sku: "B-00292-0",
        subfamilia: "ESPARRAGOS VARIOS",
        stock: "1",
        familia: "B-",
        nombre: "ESPARRAGO 7/100X40",
      },
      {
        familia: "B-",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
        sku: "B-00293-0",
        subfamilia: "ESPARRAGOS CILINDRO",
        stock: "4",
        precio: "136.151",
        nombre: "ESPARRAGO CILINDRO SIAM T.V",
      },
      {
        stock: "0",
        precio: "226.246",
        familia: "B-",
        nombre: "TUERCA CILINDRO SIAM T.V.",
        sku: "B-00294-0",
        subfamilia: "TUERCAS",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
      },
      {
        precio: "148.152",
        subfamilia: "B-",
        sku: "B-00295-0",
        familia: "B-",
        nombre: "TAMBORCITO VARILLA FRENO ZLLA º7",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
        stock: "9",
      },
      {
        stock: "1",
        precio: "2992.751",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
        subfamilia: "EXTRACTORES VOLANTE",
        familia: "B-",
        nombre: "EXTRACTOR VOL.Y PIÑON ZLLA 175",
        sku: "B-00297-0",
      },
      {
        familia: "B-",
        sku: "B-00298-0",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
        stock: "12",
        precio: "2595.632",
        subfamilia: "EXTRACTORES VOLANTE",
        nombre: "EXTRACTOR VOL.Y PIñON ZLLA 125",
      },
      {
        precio: "2450.538",
        stock: "188",
        nombre: "EXTRACTOR VOLANTE HERO PUCHS",
        sku: "B-00298-1",
        familia: "B-",
        subfamilia: "EXTRACTORES VOLANTE",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
      },
      {
        nombre: "ESPARRAGO CORTO CIL.ZLLA 175",
        precio: "466.769",
        sku: "B-00299-0",
        stock: "106",
        tipo: "1 - S / B / J / F / D / H  / W / R / Y",
        familia: "B-",
        subfamilia: "ESPARRAGOS VARIOS",
      }
    );
    setProductos(productos);
    let temp = productos.slice(0, 100);
    // let temp = productos;
    setProdu(temp);
    console.log(temp);
    console.log(productos);
    setDisp(true);
  }, []);

  //TODO test products

  // useEffect(() => {
  //   getDocs(collection(db, "ProductosDRN")).then((docSnap) => {
  //     docSnap.forEach((doc) => {
  //       const { codigo, nombre, producto } = doc.data();
  //       productos.push(
  //         doc.data({
  //           codigo,
  //           nombre,
  //           producto,
  //         })
  //       );
  //     });
  //     setProductos(productos);
  //     let temp = productos.slice(0, 100);
  //     // let temp = productos;
  //     setProdu(temp);
  //     console.log(temp);
  //     console.log(productos);
  //     setDisp(true);
  //   });
  // }, []);

  useEffect(() => {
    if (search == "") {
      let temp = productos.slice(0, 40);
      setProdu(temp);
    } else {
      const results = productos.filter((item) => {
        return (
          item.nombre.toUpperCase().indexOf(search.toUpperCase()) > -1 ||
          item.sku.toUpperCase().indexOf(search.toUpperCase()) > -1
        );
      });
      setProdu(results);
    }
  }, [search]);

  if (disp) {
    return (
      <ScrollView>
        <Header title={"Tienda"} navigation={navigation} />
        <ScrollView>
          <TextInput
            onChangeText={(text) => setCliente(text)}
            value={cliente}
            style={styles.searchBar}
            placeholder="Seleccionar Cliente..."
          />
          <TextInput
            onChangeText={(text) => setSearch(text)}
            value={search}
            style={styles.searchBar}
            placeholder="Buscar..."
          />
          {/* <Button onPress={() => setSearch("s-")} title="SCAR" /> */}
          {search != "" && (
            <TouchableOpacity onPress={() => setSearch("")}>
              <View style={styles.centerThis}>
                <View style={styles.results}>
                  <Text style={styles.resultsText}>
                    {produ.length} Resultados
                  </Text>
                  <Text style={styles.resultsText}>X</Text>
                </View>
              </View>
            </TouchableOpacity>
          )}
          {/* GRID SELECTOR */}
          <View style={{ display: "flex", flexDirection: "row" }}>
            <Ionicons name="grid-outline" size={20} color="#0301C5" />
            <Switch
              trackColor={{ false: "#767577", true: "#81b0ff" }}
              thumbColor={typeGrid ? "#f5dd4b" : "#f4f3f4"}
              ios_backgroundColor="#3e3e3e"
              onValueChange={() => {
                setTypeGrid((previousState) => !previousState);
              }}
              value={typeGrid}
            />
            <Ionicons name="menu-outline" size={20} color="#0301C5" />
          </View>
          {cliente != "" && <Collection products={produ} type={typeGrid} />}
        </ScrollView>
        {/* <Button
            onPress={() => navigation.navigate("Firebase")}
            title="FIREBASE"
          />
          <Button onPress={() => navigation.navigate("XML")} title="XML" /> */}
        {/* <Button
          title="Cerrar Sesión"
          buttonStyle={styles.button}
          titleStyle={styles.btnTitle}
          onPress={logOut}
        /> */}
      </ScrollView>
    );
  } else {
    return <Text>Loading...</Text>;
  }
};

export default StoreAdmin;
